const DOWNLOAD_REQUESTED = 'safe/download/requested'
const DOWNLOAD_SUCCEEDED = 'safe/download/succeeded'
const DOWNLOAD_FAILED = 'safe/download/failed'

export {DOWNLOAD_REQUESTED, DOWNLOAD_SUCCEEDED, DOWNLOAD_FAILED}
